import { render, staticRenderFns } from "./FeishuLogin.vue?vue&type=template&id=152c6f5c&scoped=true&"
import script from "./FeishuLogin.vue?vue&type=script&lang=js&"
export * from "./FeishuLogin.vue?vue&type=script&lang=js&"
import style0 from "./FeishuLogin.vue?vue&type=style&index=0&id=152c6f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c6f5c",
  null
  
)

export default component.exports